'use client';

import { useMemo } from 'react';

import { Button } from '~/components/Button/Button';
import { CardActivityReportDetail } from '~/components/Card/CardActivityReportDetail';
import { PostT } from '~/state/post';

const Card = ({ post }: { post: PostT }) => {
  const link = useMemo(() => {
    if (post.postable_corporate) {
      return `/corporates/${post.postable_corporate.uid}/${post.id}`;
    }

    if (post.postable_organization) {
      return `/orgs/${post.postable_organization.uid}/${post.id}`;
    }

    return `/posts/${post.id}`;
  }, [post]);

  return (
    <CardActivityReportDetail
      link={link}
      areaText={post.location?.label}
      categoryList={post.tags.map((t) => t.name)}
      text={post.detail || ''}
      title={post.title}
      src={post.content_image}
    />
  );
};

type Props = {
  posts: PostT[];
};

export const Reports = ({ posts }: Props) => {
  return (
    <div className='flex flex-col items-center gap-16 p-16'>
      <p className='text-title-strong-medium text-accent'>活動報告</p>
      <div className='flex flex-row flex-wrap justify-center gap-4'>
        {posts.map((p, i) => (
          <Card key={i} post={p} />
        ))}
      </div>
      <Button variant={'basic'} isShowArrowIcon link={{ href: '/activities/intilaq' }}>
        もっと見る
      </Button>
    </div>
  );
};
